import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  type: "button",
  class: "bg-white dark:bg-dark-600 p-1 rounded-full text-gray-500 dark:text-dark-300 hover:text-gray-800 dark:hover:text-dark-100 focus:outline-hidden"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Select Dark/Light Mode", -1)

import { ref, onMounted } from "vue";
import { MoonIcon, SunIcon } from "@heroicons/vue/outline";


export default /*#__PURE__*/_defineComponent({
  __name: 'ThemeSelector',
  setup(__props) {

const darkMode = ref(false);

onMounted(() => {
  darkMode.value =
    localStorage.theme === "dark" ||
    (!("theme" in localStorage) &&
      window.matchMedia("(prefers-color-scheme: dark)").matches);
});

function enableDarkMode() {
  darkMode.value = true;
  localStorage.theme = "dark";
  document.documentElement.classList.add("dark");
}

function enableLightMode() {
  darkMode.value = false;
  localStorage.theme = "light";
  if (document.documentElement.classList.contains("dark")) {
    document.documentElement.classList.remove("dark");
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", _hoisted_1, [
    _hoisted_2,
    (darkMode.value)
      ? (_openBlock(), _createBlock(_unref(SunIcon), {
          key: 0,
          onClick: enableLightMode,
          title: "Turn on Light Mode (white background)",
          class: "h-6 w-6",
          "aria-hidden": "true"
        }))
      : (_openBlock(), _createBlock(_unref(MoonIcon), {
          key: 1,
          onClick: enableDarkMode,
          title: "Turn on Dark Mode (black background)",
          class: "h-6 w-6",
          "aria-hidden": "true"
        }))
  ]))
}
}

})